import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ptpreport',
  templateUrl: './ptpreport.component.html',
  styleUrls: ['./ptpreport.component.css']
})
export class PtpreportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
